import Image from 'next/image';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './media.scss';

type Props = ComponentPropsWithoutRef<typeof Image>;
export const MediaImage = ({
    width,
    height,
    blurDataURL,
    className,
    fill,
    alt,
    priority,
    ...props
}: Props) => {
    return (
        <Image
            {...(width !== undefined && height !== undefined && !fill ? { width, height } : { fill: true })}
            sizes="100vw"
            draggable={false}
            className={cn('media', className)}
            placeholder={blurDataURL ? 'blur' : undefined}
            blurDataURL={blurDataURL}
            priority={priority}
            {...(priority ? {} : { loading: 'lazy' as const })}
            data-testid="media-image"
            alt={alt}
            {...props}
        />
    );
};
